var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIdcardicon3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 10,
    viewBox: "0 0 9 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.41132 2.48698C6.04506 1.12071 3.82884 1.12071 2.46159 2.48797C1.09532 3.85522 1.09532 6.07144 2.46257 7.4377C3.82983 8.80397 6.04605 8.80397 7.41231 7.4377C8.06879 6.78123 8.43702 5.89078 8.43702 4.96183C8.43702 4.03388 8.0678 3.14346 7.41132 2.48698ZM6.73808 6.33799V6.337L6.56038 6.51371C6.33136 6.7457 5.99671 6.84144 5.67982 6.76542C5.35997 6.67954 5.05591 6.54332 4.7795 6.36168C4.52184 6.19781 4.28393 6.0053 4.06873 5.78911C3.8703 5.59266 3.6926 5.37646 3.53761 5.14546C3.3688 4.8957 3.23355 4.62423 3.13878 4.33795C3.0292 4.00132 3.12004 3.63308 3.37177 3.38431L3.57909 3.17702C3.63634 3.11878 3.73011 3.11878 3.78836 3.17702L4.44386 3.8325C4.50211 3.89074 4.50211 3.98355 4.44386 4.04179L4.05885 4.42679C3.94828 4.53637 3.93448 4.71012 4.02629 4.8355C4.16548 5.02701 4.31947 5.20667 4.48729 5.37351C4.67387 5.56107 4.87722 5.73185 5.0944 5.88289C5.21978 5.96976 5.38958 5.95593 5.49817 5.84833L5.87034 5.47025C5.92859 5.41201 6.02137 5.412 6.07961 5.46926C6.07961 5.46926 6.07961 5.46926 6.07961 5.47025L6.73611 6.12771C6.79435 6.18595 6.79435 6.27974 6.73611 6.337L6.73808 6.33799Z",
    fill: "#E31F25"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIdcardicon3);
export default __webpack_public_path__ + "static/media/idcardicon3.70cc45eb2065dd71c54f9bd063eb20e0.svg";
export { ForwardRef as ReactComponent };